
















import { Component, Vue } from 'vue-property-decorator';
import { TokenUser } from '@/TokenUser'
import * as utils from '@/utils';
import * as utils_auth from '@/utils_auth';
import * as utils_tracker from '@/utils_tracker';
import ModalWrapperComponent from '@/components/ModalWrapperComponent.vue';             // @ is an alias to /src
import { globalUC } from '../UserCache';


@Component({
  name: 'DiscordConfirm',
  components: { ModalWrapperComponent }
})
export default class DiscordConfirmView extends Vue {
  // prop reactive member variables publically available to the html template

  // public reactive member variables available to the html template
  public discordConfirmationCode: string

  public get loading(): boolean { return this.$store.state.loading }
  public get isAuthenticated(): boolean { return this.$store.getters.isAuthenticated }
  public get user(): TokenUser { return this.$store.getters.userObject }
  public get userId(): string { return this.$store.getters.userId }

  // public functions available to the html template
  public userChoseRegister(): void {
    utils_auth.setLocationAfterLogin({ name: 'discordConfirm', params: { code: this.discordConfirmationCode }}); // stores it in local storage
    (this.$refs.RegisterFormModalComponent as ModalWrapperComponent).show('LiveToken Registration', 'sm', null)
  }
  public userChoseLogin() {
    utils_auth.setLocationAfterLogin({ name: 'discordConfirm', params: { code: this.discordConfirmationCode }}); // stores it in local storage
    (this.$refs.LoginFormModalComponent as ModalWrapperComponent).show('LiveToken Login', 'sm', null)
  }

  // private, non-reactive member variables

  // private functions not available directly to HTML template
  private async mounted() {
    if (this.$store.state.devmode) console.log(`${this.$options.name} mounted()`)

    utils_tracker.page(this.$options.name)

    // get code from URL
    this.discordConfirmationCode = this.$route.params.code

    // send to server to link this user to the discord GuildMember stored in redis
    if (this.user) await this.fetchData()
  }

  private async fetchData(): Promise<void> {

    this.$store.commit('setLoading', { loading: true });
    try {
        let url: string = utils.getURLprefix() + '/api/auth/discordConfirmCode'
        url += `?code=${this.discordConfirmationCode}`
        const response: any = await utils.makeGetCall(url);

        // error check
        if (response.data.error) {
          this.$store.commit('setLoading', { loading: false });
          try { await this.$router.push({ name: 'home', params: { title: 'Error', msg: response.data.error }}) } catch (Error) {}
          return
        }

        // if got user and/or sessionId back, then log them in as if it were a magic url
        if (response.data.user) {
          const user: TokenUser = new TokenUser(response.data.user)
          user.email = response.data.email     // this got stripped away to make safe for client
          utils_auth.saveAuthStuffToStoreAndLocalStorage(user, response.data.sessionId)
          globalUC.add(user)      // might as well give cache the very latest one

          try { await this.$router.push({ name: 'home', params: { title: 'Success', msg: response.data.message }}) } catch (Error) {}
        }


    } catch (error) {
      utils.toast(this, 'Error', 'Could not confirm code')
      if (this.$store.state.devmode) console.log(error);
    } finally {
      this.$store.commit("setLoading", { loading: false });
    }


  }

}

